import { useWorkspacesMenu, useSystemWorkspacesMenu, Workspace } from 'contexts/WorkspaceContext';
import shortid from 'shortid';

export const useCloneWorkspace = ({
  workspaceId,
  newType,
}: {
  workspaceId: string;
  newType: 'user' | 'system';
}) => {
  const {
    userWorkspaces,
    loading: userLoading,
    addWorkspace: addUserWorkspace,
  } = useWorkspacesMenu();
  const {
    systemWorkspaces,
    loading: systemLoading,
    addWorkspace: addSystemWorkspace,
  } = useSystemWorkspacesMenu();

  const ready = !(userLoading || systemLoading);

  if (!ready) {
    return {
      ready,
      save: (_noop: string) => {
        return Promise.reject();
      },
    };
  }

  const user = userWorkspaces?.find((w) => w.id === workspaceId);
  const system = systemWorkspaces?.find((w) => w.id === workspaceId);
  const workspaceSource = user ?? system;

  const newId = shortid();

  const clonedWorkspace: Workspace = {
    ...workspaceSource!,
    id: newId,
    isSystem: newType === 'system',
  };

  const save = (newTitle: string) => {
    const newWorkspace = { ...clonedWorkspace, title: newTitle };

    if (newType === 'system') {
      return addSystemWorkspace(newWorkspace);
    } else {
      return addUserWorkspace(newWorkspace);
    }
  };
  return {
    ready,
    save,
  };
};
